module.exports = __webpack_public_path__ + "img/5.bc126259.jpg";